import { writable } from 'svelte/store';

// Helper functions
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value, days = 365) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
}

// Initialize store
// Default = true (English) if cookie not set
const initialCookie = getCookie('isEnglish');
const initial = initialCookie === null ? true : initialCookie === 'true';

export const isEnglish = writable(initial);

// Function to toggle or set value
export function setIsEnglish(value) {
  isEnglish.set(value);
  setCookie('isEnglish', value);
}
